/* eslint-disable prettier/prettier */
export const normalizeBoolean = (input) => {
	if (typeof input === "boolean") {
		return input
	}
	if (input === null) {
		return null
	}
	if (input === "true") {
		return true
	}
	if (input === "false") {
		return false
	}
	return null
}
